export default __webpack_public_path__ + "static/media/mexico.07342499.png";